import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {CONFIG} from "../app/config";
import {DataService} from "../providers/data-service";
import {GeolocationService} from "../providers/geolocation-service";
import {Util} from "../app/util";
import {StorageService} from "../providers/storage-service";
import {MessageService} from "../providers/message-service";
import {TSoftware} from "../app/enum";

@Injectable()
export class BridgeInterceptor implements HttpInterceptor {

    constructor(public geolocationService: GeolocationService,
                public dataService: DataService,
                public messageService: MessageService,
                public util: Util,
                public storageService: StorageService) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Bridge Only
        if (!(req.url.indexOf('SYNC') !== -1 || req.url.indexOf('DESK') !== -1 || req.url.indexOf('index.php') !== -1)) {
            return next.handle(req);
        }

        let clone = this.parseRequest(req);

        // update url (config bridge, geolocal, device infos e flags)
        return next.handle(clone)

        // trabalha resultado da bridge
            .do((res: any) => {

                //if (ev instanceof HttpResponse) {
                return this.parseResponseBridge(res);
                //}

            })

            // erros de conexão e throws do map acima (se tem Result)
            .catch((event: any) => {

                return this.parseResponseError(event, req.url);

                //if (event instanceof HttpErrorResponse) {
                //    return this.catch401(event);
                //}

            });

    }

    private parseRequest(req: any): any {

        let url = req.url + (req.url.indexOf('?') >= 0 ? '' : '?');

        if (url.substr(0, 4) !== 'http') {
            url = CONFIG.paths.bridge + CONFIG.paths.bridgePorta + '/' + url;
        }

        //console.log(url);

        //injector EXEMPLE:
        //public injector: Injector,
        //let authService: LogadoService = this.injector.get(LogadoService);
        //authService.getAuth().Sessao;

        if (CONFIG.data.brandap) {
            url = url.split('?')[0] + '?' + 'BrandapID=' + CONFIG.data.brandap.BrandedID + '&' + url.split('?')[1];
        }

        url +=
            '&utf8=1' +

            '&Sessao=' + (this.dataService.get('LOGADO-SESSAO') || '') +
            '&Referrer=' + (this.dataService.get('referrer') || '') +

            '&Rotalat=' + this.geolocationService.getLocation().latitude +
            '&Rotalon=' + this.geolocationService.getLocation().longitude +

            '&Software=' + TSoftware.swHandapp;

        if (CONFIG.data.device) url +=
            '&DevicerBios=' + CONFIG.data.device.DevicerBios +
            '&DevicerFrom=' + CONFIG.data.device.DevicerFrom +
            '&DevicerHttp=' + CONFIG.data.device.DevicerHttp +
            '&DevicerFirm=' + CONFIG.data.device.DevicerFirm +
            '&DevicerSoft=' + CONFIG.data.device.DevicerSoft +
            '&DevicerHard=' + CONFIG.data.device.DevicerHard +
            '&DevicerHash=' + CONFIG.data.device.DevicerHash +
            '&DevicerNome=' + CONFIG.data.device.DevicerNome + //EXCLUIR ? Nao esta gravando pois não vem mais!
            '&DevicerPush=' + CONFIG.data.device.DevicerPush +
            '&DeviceBundle=' + CONFIG.data.device.DeviceBundle +
            '&DeviceDomain=' + CONFIG.data.device.DeviceDomain;

        return req.clone({/*responseType: responseType,*/ url: url});

    }

    private parseResponseBridge(res: any): any {

        // getImage
        if (!res.url || (res.url.indexOf('SYNC') < 0 && res.url.indexOf('DESK') < 0)) {
            return res;
        }


        // Bridge Request
        if (res.body.Bridge) {
            CONFIG.paths.bridge = res.body.Bridge;
            throw res;
        }
        else { // resposta da assistência

            // verifica se está forçado via developer para voltar valor configurado
            this._bridgeServer();
        }


        // Action Process
        (window as any).handappMainInstance.handappAction(res);

        if (res.body.Result) {

            if (!res.body.Titulo) res.body.Titulo = 'Ops!';
            res.body.isBridgeResult = true;
            throw res;

        }

        return res;

    }

    private parseResponseError(erro: HttpResponse<any> | any, url: string): any {

        // Observable.throw para catch e throw para Observable.do
        if (erro.body && erro.body.Bridge) {
            return Observable.throw(erro.body);
        }

        //REQUEST LOOP
        if ((window as any).handappMainInstance.requestLoop) return Observable.throw(erro.body);

        //Action Expira        
        if (erro.body && erro.body.Logout == '#EXPIRADO#') {
            (window as any).handappMainInstance.requestLoop = true;
            setTimeout(() => (window as any).handappMainInstance.requestLoop = false, 5000);
            (window as any).handappMainInstance.handappLogout();
        }
            
            
        if (erro.body && (erro.body.Result || erro.body.Toaste)) {
            if (!erro.body.Titulo) erro.body.Titulo = 'Ops!';
            return Observable.throw(erro.body); // erro vindo do handleBridgeResponse (result ou status != 200)
        }

        // verifica se está forçado via developer para voltar valor configurado, usado quando tem assistência
        this._bridgeServer();

        let monitorDesk = (url.indexOf('/DESK-') >= 0);
        if ( monitorDesk) return Observable.throw(CONFIG.request.monitorErroPadrao); // erro disparado pelo http do angular
        if (!monitorDesk) return Observable.throw(CONFIG.request.bridgeErroPadrao);  // erro disparado pelo http do angular

    }

    private _bridgeServer() {

        this.storageService.get('BRIDGE-SERVER')
            .subscribe(data => {

                CONFIG.paths.bridge = data ? data : CONFIG.paths.bridgeMainway;

            });

    }

}



// WEBPACK FOOTER //
// ./src/interceptors/bridge-interceptor.ts